export const formatDate = (date) =>{
  var monthNames = [
    "Jan", "Feb", "Mar",
    "Apr", "May", "Jun", "Jul",
    "Aug", "Sep", "Oct",
    "Nov", "Dec"
  ];

  var day = date.getDate();
  var monthIndex = date.getMonth();
  var year = date.getFullYear();
  var hour = date.getHours();
  var min = date.getMinutes();

  return day + '/'
    + monthNames[monthIndex] + '/'
    + year + " " + (hour<10?'0':'')
    + hour + ":" + (min<10?'0':'')
    + min;
}